import { render, staticRenderFns } from "./ApplicationsManager.vue?vue&type=template&id=7a4e941c"
import script from "./ApplicationsManager.vue?vue&type=script&lang=js"
export * from "./ApplicationsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports